import _ from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import styles from "./boxStorageCom.module.scss";
import { Modal, Popconfirm, message } from "antd";
import iconpng from "../../../../styles/images/svg.svg";
import iconexe from "../../../../styles/images/exe.svg";
import { TPIService } from "../../../../base/tpiService";
import { URInput } from "../../../../shared/widgets/input";
import Group1 from "../../../../styles/images/folderImg.png";
import { URButton } from "../../../../shared/widgets/button";
import iconppt from "../../../../styles/images/grid_ppt.svg";
import iconpdf from "../../../../styles/images/grid_pdf.svg";
import iconxls from "../../../../styles/images/grid_xls.svg";
import iconzip from "../../../../styles/images/grid_zip.svg";
import iconword from "../../../../styles/images/fileword.svg";
import Group from "../../../../styles/images/boxlogoblue.svg";
import { URCheckBox } from "../../../../shared/widgets/checkbox";
import iconmusic from "../../../../styles/images/wave-thumbnail.svg";
import iconotherformat from "../../../../styles/images/otherformat.svg";
import iconvideo from "../../../../styles/images/Mp4.svg";
import {  pptFormats, imageFormat,mp3Formats, zipFormats, pdfFormats, 
  wordFormats, excelFormats, boxFileDetails, getBoxFolder, getBoxAPISearch, videoFormat } from "../../../../base/utils";
import {config} from '../../../../base/constant'
import store from "../../../../context/store/store";
const text = (
  <>
    <div className={`addfilespop ${styles.addfilespop}`}>
      <ul>
        <li className="active">Upload</li>
        <li>New folder</li>
      </ul>
    </div>
  </>
);
const description = "Delete the task";

const confirm = () => {
  message.info("Clicked on Yes.");
};

type boxState = {
  isConfirmPopUp: boolean;
  isBoxPop: boolean;
  boxFoldersList: any;
  listOfSelectedItems:any;
  selectedFileDetials:any;
  searchKey:string;
  searchResults: any;
};

const BoxStorage = () => {
  let meetingReducer: any = store.getState().meetingReducer;
  const {planBased} =meetingReducer;
  let stateKey1 = Math.random().toString(18).substr(2);
  let stateKey2 = Math.random().toString(2).substr(2);
  let totalStatekey = stateKey1 + stateKey2;
  const [getBoxModal, setBoxModal] = useState<boxState>({
    isConfirmPopUp: false, isBoxPop: false,
    boxFoldersList: {}, listOfSelectedItems:[],selectedFileDetials:[],
    searchKey:'',searchResults:''
  });
  const [boxbtnhide, setBoxbtnhide] = useState(false);
  

  const handleBox = async () => {

    let boxAuthUrl = `${config().BOX_AUTH_URL}?response_type=code&state=${totalStatekey}&redirect_uri=${window.location.origin}/box/callback&client_id=${config().BOX_CLIENT_ID}`;

    setBoxModal({ ...getBoxModal, isConfirmPopUp: false });
    window.open(
      boxAuthUrl,
      "sharer",
      "toolbar=0,status=0,width=900,height=518,top=120,resizable=0 left=500,right=200"
    );
  };

  const boxAuthorizing = async () => {
    let boxKey = localStorage.getItem("boxStorageValue");

    if (boxKey) {
      let folderList: any = await getBoxFolder();
      if(folderList) {
        setBoxModal({
          ...getBoxModal,
          isBoxPop: true,
          boxFoldersList: folderList
        });
      }
      else {
        localStorage.removeItem('boxStorageValue');
        setBoxModal({ ...getBoxModal, isConfirmPopUp: true });

      }
    } else {
      setBoxModal({ ...getBoxModal, isConfirmPopUp: true });
    }
  };


  const selectedItems = async(itemId:any) => {
    let {listOfSelectedItems, selectedFileDetials,boxFoldersList} = getBoxModal;
    let selectedIndex = listOfSelectedItems.indexOf(itemId);
    if(selectedIndex === -1) {
      let newDetails =  await boxFileDetails(itemId);
         if(newDetails && newDetails?.shared_link) {
            let findSelectedItem = _.find(boxFoldersList.entries, { 'id': itemId});
            findSelectedItem.url = newDetails.shared_link.url
            selectedFileDetials.push(findSelectedItem); 
            listOfSelectedItems.push(itemId);
          }
          else {
            localStorage.removeItem('boxStorageValue');
            setBoxModal({ ...getBoxModal, listOfSelectedItems: [],selectedFileDetials: [],isConfirmPopUp:false, isBoxPop:true});
        }
    }
    else {
       listOfSelectedItems.splice(selectedIndex, 1);
       selectedFileDetials.splice(selectedIndex, 1);
      }

    setBoxModal({ ...getBoxModal, listOfSelectedItems: listOfSelectedItems,selectedFileDetials: selectedFileDetials});
  }

  const getSearch=async(e:any)=> {
    setBoxModal({...getBoxModal,  searchKey:e.target.value});
    let searchStr = e.target.value;
    let searchRes:any =[];
    if(searchStr) {
      searchRes = await getBoxAPISearch(e.target.value);
    }
    else {
      searchRes = await getBoxFolder();
    }
    setBoxModal({...getBoxModal, searchKey:e.target.value, boxFoldersList:searchRes});
  }
  
  const sendToChatBottomArea=()=> {
    if(getBoxModal.selectedFileDetials.length >=1) {
      TPIService.boxFileUpload(getBoxModal.selectedFileDetials);
    }
    setBoxModal({ ...getBoxModal, listOfSelectedItems: [],selectedFileDetials: [], isBoxPop:false});
  }

  useEffect(() => {
   
    // {Chat attach file - Box}
    const BoxShareFeature = planBased.find((item:any) => item.featureid === 789);
    if (BoxShareFeature && BoxShareFeature.value1 === "Yes") {
      setBoxbtnhide(false); 
    } else {
      setBoxbtnhide(true);
    }
    
  }, [planBased]); 

  return (
    <>
      <li className={`${boxbtnhide ? 'disabledIcon':''}`} onClick={boxAuthorizing}>
        <span className={styles.boximgleft}></span>
        Box
      </li>
      <Modal
        visible={getBoxModal.isConfirmPopUp}
        className={`${styles.flipcallmodal} ${"modaloverwrite"}`}
      >
        <span
          className={`icon_close ${styles.cursorTop}`}
          onClick={() => {
            setBoxModal({ ...getBoxModal, isConfirmPopUp: false });
          }}
        />
        <h2>Import files from Box</h2>
        <p>
          {" "}
          You must allow Worktual to have access to your files and make sure
          pop-ups are enabled in the browser.
        </p>
        <div className={styles.footersection}>
          <URButton
            className={styles.cancelbtn}
            name="Ok"
            onClick={handleBox}
          ></URButton>
        </div>
      </Modal>
      <Modal
        visible={getBoxModal.isBoxPop}
        className={`${styles.flipcallmodal} ${
          styles.boxfilecon
        } ${"modaloverwrite boxmodalsec"}`}
      >
        <div className={styles.headerbox}>
          <div className={styles.leftlogo}>
            {" "}
            <img src={Group} alt="" />
          </div>
          <div>
            <URInput
              value={getBoxModal.searchKey}
              onChange={getSearch}
              placeHolder="Search files and folders"
              className={`${styles.boxsearch} leftbarsearch` }
            ></URInput>
          </div>
        </div>
        {/* <div className={`${styles.helpers}`}>
          <h4>All Files</h4>
          <Popconfirm
            placement="bottomRight"
            title={text}
            //description={description}
            onConfirm={confirm}
            okText="Yes"
            cancelText="No"
            overlayClassName="Addfiles"
          >
            <span className="icon_plus"></span>
          </Popconfirm>
        </div> */}

        <div className={styles.innerbdyconsec}>
          {getBoxModal.boxFoldersList.total_count >0 && 
          Array.isArray(getBoxModal.boxFoldersList.entries) && getBoxModal.boxFoldersList.entries.length >=1 ?
          getBoxModal.boxFoldersList.entries.map((elem:any, index:any)=> {

            let modifiedDate = moment(new Date(elem.modified_at)).format('MMM ddd d yyyy')
            return (
              <div key={index} className={styles.filesecmaincon}>
              <div className={styles.leftfileimg}>
                <img src={elem.type === "folder"
                    ? Group1 :
                    mp3Formats.indexOf(elem.extension) !== -1 ? iconmusic :
                    pptFormats.indexOf(elem.extension) > -1 ? iconppt : 
                    zipFormats.indexOf(elem.extension) !== -1 ? iconzip :
                      pdfFormats.indexOf(elem.extension) !== -1 ? iconpdf :
                        wordFormats.indexOf(elem.extension) !== -1 ? iconword :
                        imageFormat.indexOf(elem.extension) !== -1 ? iconpng :
                       (elem.extension === 'exe')? iconexe :
                              excelFormats.indexOf(elem.extension) !== -1 ? iconxls : 
                              videoFormat.indexOf(elem.extension) !== -1 ? iconvideo:
                              iconotherformat
                  } alt="fileName" /></div>
              <div className={styles.leftfilmiddlconten}>
                <h5 className={styles.headtxt}>{elem.name}</h5>
                <h5 className={styles.headtxt}>{`Modified ${modifiedDate}`}</h5>
              </div>
              {elem.type !== "folder" &&
              <div className={styles.lefticoncheck}>
                <URCheckBox 
                onChange={()=> selectedItems(elem.id)} 
                className={styles.checkBoxes} 
                checked={getBoxModal.listOfSelectedItems.includes(elem.id) ? true : false} />
              </div>}
            </div>
            )
          })
          :
          <>no files in your box----</>
          }
         
        </div>

        <div>
      <ul>
  
      </ul>
      <div>
      </div>
    </div>

        {/* <p> You must allow Worktual to have access to your files and make sure pop-ups are enabled in the browser.</p> */}
        <div className={styles.footersectionbox}>
          <div className={styles.footerlfttxt}>
            <span>{getBoxModal.listOfSelectedItems.length} Selected</span>
            <span onClick={()=> {setBoxModal({ ...getBoxModal, listOfSelectedItems: [],selectedFileDetials:[] })} }>Deselect</span>
          </div>
          <div>
            <URButton className={styles.endAll}
            onClick={()=>{ setBoxModal({
              ...getBoxModal,
              isBoxPop: false,listOfSelectedItems:[],selectedFileDetials:[],searchKey:''
            })}} name="Close"></URButton>
            <URButton
              className={styles.cancelbtn}
              name="Choose"
              onClick={sendToChatBottomArea}
            ></URButton>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default BoxStorage;
